import { SyntheticEvent } from "react";
import { motion } from "motion/react";
import swapIcon from "@icons/swap.svg";
import useWindowSize from "@utils/use_window_size";
import Image from "next/image";
import { isMobile } from "@hudson/ui/lib/utils";
import styles from "@styles/Upfront.module.css";

function SwapButton({
  disabled,
  onSwap,
  y,
}: {
  disabled?: boolean;
  onSwap: (e: SyntheticEvent) => void;
  y: number;
}): JSX.Element {
  const [size] = useWindowSize();
  return (
    <div className="relative z-10">
      <motion.button
        aria-label="Swap"
        disabled={disabled}
        whileTap={{ scale: 0.9 }}
        style={{
          position: "absolute",
          right: isMobile() ? "3rem" : "-16px",
          top: `${y}px`,
          transform: `rotate(${size < 1080 ? 90 : 0}deg)`,
        }}
        className={`${styles.background} ${styles.buttonHover} ${styles.focusOutline} absolute inline-flex items-center p-1 border-4 border-white rounded-xl z-10 normal:w-9 ${disabled ? "opacity-50 cursor-not-allowed" : ""}`}
        type="button"
        onClick={onSwap}
      >
        <Image alt="swap" src={swapIcon} height={20} width={20} priority />
      </motion.button>
    </div>
  );
}

export default SwapButton;
